import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/tocTF/tflogo.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-2ee3b58c")

_pushScopeId("data-v-2ee3b58c")
const _hoisted_1 = { class: "tocV3_headTip" }
const _hoisted_2 = { class: "tocV3_topText" }
const _hoisted_3 = { class: "tocV3_topText_flex" }
const _hoisted_4 = {
  key: 0,
  class: "brandlogo_wrapper"
}
const _hoisted_5 = { class: "tocV3_topText_one" }
const _hoisted_6 = {
  key: 1,
  class: "tocV3_topText_xny"
}
const _hoisted_7 = { class: "ptb5" }
const _hoisted_8 = { class: "tocV3_topText_small" }
const _hoisted_9 = { class: "tocV3_topText_small" }
const _hoisted_10 = {
  key: 0,
  class: "tocV3_banner_cheKuang_main"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 本报告检测内容或检测结论仅供参考，不可作为车辆交易凭证或其他追责凭据;如您或其他第三方参考本报告进行被检测车辆交易或其他相关活动，对应结果均由您及/或该第三方自行承担，与腾发无关且腾发不承担任何责任(包括但不限于检测失误责任等)。 ")
const _hoisted_12 = {
  key: 1,
  class: "head_promise_result_wrap"
}
const _hoisted_13 = { class: "head_promise_wrapper" }
const _hoisted_14 = { class: "vector_description" }
const _hoisted_15 = { class: "result_wrap" }
const _hoisted_16 = { class: "resBox_top" }
const _hoisted_17 = { class: "top_level" }
const _hoisted_18 = { class: "top_levelDes" }
const _hoisted_19 = { class: "resbox_bottom" }
const _hoisted_20 = { class: "rectangle_resBox" }
const _hoisted_21 = { class: "rectangle_resBox_item_txt" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "divide_line" }, null, -1)
const _hoisted_23 = { class: "result_bottom" }
const _hoisted_24 = /*#__PURE__*/_createVNode("img", {
  class: "localIcon",
  src: _imports_0
}, null, -1)
const _hoisted_25 = { class: "toc_ui__headTip_content_report_num" }
const _hoisted_26 = { class: "buyCarTip" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_popup = _resolveComponent("van-popup")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          (_ctx.state.brandLogo && _ctx.state.brandLogo.length)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode("img", {
                  src: _ctx.state.brandLogo,
                  class: "tocV3_topText_brandlogo"
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_5, _toDisplayString(_ctx.state.brandName), 1),
          (_ctx.state.isXNY)
            ? (_openBlock(), _createBlock("div", _hoisted_6, "新能源"))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_7, [
            (_ctx.state.productName && _ctx.state.productName.length)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: ["productname_wrapper productname_bg", {"productname_bg_499": _ctx.state.reportMsg.Rp499(),"productname_bg_699": _ctx.state.reportMsg.Rp699() || _ctx.state.reportMsg.Rp799(),"productname_bg_hc": _ctx.state.reportMsg.RpHC()}]
                }, [
                  _createVNode("span", {
                    class: ["productname_font productname", {"productname_499": _ctx.state.reportMsg.Rp499(),"productname_699": _ctx.state.reportMsg.Rp699() || _ctx.state.reportMsg.Rp799(),"productname_hc": _ctx.state.reportMsg.RpHC()}],
                    text: _ctx.state.productName
                  }, _toDisplayString(_ctx.state.productName), 11, ["text"])
                ], 2))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_8, _toDisplayString(_ctx.state.modelName), 1),
        _createVNode("div", _hoisted_9, "VIN: " + _toDisplayString(_ctx.state.vin), 1)
      ]),
      (_ctx.state.reportMsg.RpCK())
        ? (_openBlock(), _createBlock("div", _hoisted_10, [
            _createVNode("img", {
              src: require('../../../assets/tocV3/tipIcon.png')
            }, null, 8, ["src"]),
            _hoisted_11
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_12, [
            (_ctx.state.isSF)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: ["head_promise_bg", _ctx.getHeadPromiseBgStyle()],
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.reportMsg.RpSRZ()? _ctx.setShowProtect() : _ctx.toExplain('check')))
                }, [
                  _createVNode("div", _hoisted_13, [
                    _createVNode("div", _hoisted_14, [
                      _createVNode("img", {
                        class: "vector",
                        src: _ctx.getVectorIcon(),
                        alt: ""
                      }, null, 8, ["src"]),
                      _createVNode("span", {
                        class: ["promiseMsg", _ctx.getPromiseMsgFont()],
                        text: _ctx.state.promiseMsg
                      }, _toDisplayString(_ctx.state.promiseMsg), 11, ["text"])
                    ]),
                    _createVNode("img", {
                      class: "headArrowRight",
                      src: _ctx.getRightArrowIcon(),
                      alt: ""
                    }, null, 8, ["src"])
                  ])
                ], 2))
              : _createCommentVNode("", true),
            _createVNode("div", {
              class: ["head_result_bg", _ctx.getHeadResultBgStyle()]
            }, [
              _createVNode("div", _hoisted_15, [
                _createVNode("div", {
                  class: ["result_middle", {"result_middle_nosf": !_ctx.state.isSF}]
                }, [
                  _createVNode("div", _hoisted_16, [
                    _createVNode("div", _hoisted_17, [
                      _createVNode("img", {
                        class: "levelIcon",
                        src: _ctx.getResBoxLevelIcon(),
                        alt: ""
                      }, null, 8, ["src"]),
                      _withDirectives(_createVNode("img", {
                        class: "jiIcon",
                        src: _ctx.getResJiStyleIcon(),
                        alt: ""
                      }, null, 8, ["src"]), [
                        [_vShow, _ctx.state.rank !== null && _ctx.state.rank !== undefined]
                      ])
                    ]),
                    _createVNode("div", _hoisted_18, _toDisplayString(_ctx.state.rankDesc), 1)
                  ]),
                  _createVNode("div", _hoisted_19, [
                    _createVNode("ul", _hoisted_20, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.reportResultList, (item, index) => {
                        return (_openBlock(), _createBlock("li", {
                          class: "rectangle_resBox_item",
                          key: index
                        }, [
                          _createVNode("img", {
                            src: item.isErr === 0 ? item.baseSrc : (item.isErr === 1 ? item.src : item.otherSrc),
                            alt: ""
                          }, null, 8, ["src"]),
                          _createVNode("div", null, [
                            _createVNode("p", _hoisted_21, _toDisplayString(item.name), 1)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ], 2),
                _hoisted_22,
                _createVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createVNode("span", _hoisted_25, " NO." + _toDisplayString(_ctx.state.reportCode) + " " + _toDisplayString(_ctx.state.reportGenDate ? `| ${_ctx.state.reportGenDate.replace(/-/g,'.')}` : ''), 1)
                ])
              ])
            ], 2),
            _createVNode(_component_van_popup, {
              show: _ctx.state.showProtect,
              "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.showProtect = $event)),
              round: "",
              position: "bottom"
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_26, [
                  _createVNode("p", {
                    class: "buyCarTipItem",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toExplain('check')))
                  }, _toDisplayString(_ctx.state.showPromiseDes), 1),
                  (_ctx.state.reportMsg.RpSRZ())
                    ? (_openBlock(), _createBlock("p", {
                        key: 0,
                        class: "buyCarTipItem",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toExplain('auth')))
                      }, " 查看《付费享1年3万公里保修说明》 "))
                    : _createCommentVNode("", true),
                  _createVNode("p", {
                    class: "canbutton",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setShowProtect()))
                  }, "取消")
                ])
              ]),
              _: 1
            }, 8, ["show"])
          ]))
    ])
  ]))
})